import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Badge } from '../ui/badge';
import { Sparkles, RefreshCw } from 'lucide-react';

const AIMarketInsight = ({ category, country }) => {
  const [insight, setInsight] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchInsight = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (category && category !== 'all') params.append('category', category);
      if (country && country !== 'all') params.append('country', country);
      
      const response = await axios.get(`${API}/ai/product-recommendations?${params}`);
      setInsight(response.data.ai_insight);
    } catch (error) {
      console.error('Failed to fetch AI insight:', error);
      setInsight('Explore African products with preferential AfCFTA tariffs. Verified suppliers offer quality goods across all categories.');
    } finally {
      setLoading(false);
    }
  }, [category, country]);

  useEffect(() => {
    fetchInsight();
  }, [fetchInsight]);

  if (loading) {
    return (
      <div className="bg-gradient-to-r from-continental/5 to-tradeGold/5 rounded-lg p-4 mb-6 flex items-center gap-3">
        <div className="w-8 h-8 bg-continental/10 rounded-full flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-continental animate-pulse" />
        </div>
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="bg-gradient-to-r from-continental/5 via-transparent to-tradeGold/5 rounded-lg p-4 mb-6 border border-continental/10"
      data-testid="ai-market-insight"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 bg-gradient-to-br from-continental to-continental/70 rounded-full flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-semibold text-charcoal">AI Market Insight</span>
            <Badge variant="outline" className="text-xs bg-tradeGold/10 text-tradeGold border-tradeGold/30">
              GPT-5.2
            </Badge>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">{insight}</p>
        </div>
        <button 
          onClick={fetchInsight}
          className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
          title="Refresh insight"
        >
          <RefreshCw className="w-4 h-4 text-gray-400 hover:text-continental" />
        </button>
      </div>
    </div>
  );
};

export default AIMarketInsight;
